// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDecade as fn } from "../getDecade.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDecadeWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getDecadeWithOptions;
